<template>
  <v-card class="pa-4 my-4">
    <div class="font-weight-medium text-uppercase my-4 mb-0">
      Toggle Count of Models
    </div>
    <v-switch
      v-model="showCountOfModels"
      label="Show Count of Models'"
      hide-details
      color="primary"
    ></v-switch>
  </v-card>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue'
import { useSettingsStore } from '@/stores/settings';

const props = defineProps<{
    selectedPlacement: string
}>()

const showCountOfModels = ref(true);

const settingsStore = useSettingsStore()

onMounted(() => {
    showCountOfModels.value = settingsStore.placements.placements[props.selectedPlacement].showVehicleCount
})

watch(showCountOfModels, () => {
  settingsStore.placements.placements[props.selectedPlacement].showVehicleCount = showCountOfModels.value
})
</script>
